var render, staticRenderFns
import script from "./Contractor.vue?vue&type=script&lang=ts&"
export * from "./Contractor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4716ad42",
  null
  
)

export default component.exports